import { gql } from "@apollo/client"

const GET_SURVEY_RESULT_EMAIL = gql`
  query getSurveyResultEmail($code: String!, $surveyId: String!) {
    getSurveyResultEmail(code: $code, surveyId: $surveyId) {
      message
      statusCode
    }
  }
`

export default GET_SURVEY_RESULT_EMAIL
